import PropTypes from "prop-types"
import React from "react"
import { HiArrowNarrowLeft } from "react-icons/hi"
import { useHistory, useLocation } from "react-router-dom"
import styled from "styled-components"

import { useStateValue } from "../../context/AppStateStore"
import { toLoginWithSuccessRedirect } from "../../toolkit"
import AppButton from "../AppButton"
import logo from "./header.logo.svg"

// ----------------------------------------------------------------------------

function _Layout(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    const [{ user }, dispatch] = useStateValue()

    const history = useHistory()
    const location = useLocation()

    const isEventsPage = location.pathname === "/"

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleLogOut() {
        dispatch({
            type: "SIGN_OUT",
        })
        history.push("/")
    }

    function goToWebSite() {
        return (window.location.href = "https://www.welfarecare.org")
    }

    function renderLoginSection() {
        if (user) {
            return (
                <AppButton
                    className="login-btn"
                    onClick={handleLogOut}
                    uxType="delete"
                >
                    Esci
                </AppButton>
            )
        }
        return (
            <AppButton
                uxType="primary"
                className="login-btn"
                onClick={() =>
                    toLoginWithSuccessRedirect(history, { redirect: "/" })
                }
            >
                Accedi alla tua prenotazione
            </AppButton>
        )
    }

    function renderHeader() {
        return (
            <div className="screen-header">
                <div className="user">
                    {isEventsPage && renderLoginSection()}
                </div>
            </div>
        )
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            <header>
                <div className="top-message">
                    <HiArrowNarrowLeft className="arrow-icn" />
                    <a href="https://www.welfarecare.org">Torna alla home</a>
                </div>

                <AppButton
                    uxType="primary"
                    className="go-to-site-btn"
                    onClick={goToWebSite}
                >
                    <HiArrowNarrowLeft className="arrow-icn" />
                    Torna alla home
                </AppButton>

                <img src={logo} />
            </header>
            {renderHeader()}
            <main>{props.children}</main>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_Layout.propTypes = {
    className: PropTypes.string.isRequired,
    children: PropTypes.any,
}

_Layout.defaultProps = {}

// ----------------------------------------------------------------------------

const Layout = styled(_Layout)`
    & {
        header {
            position: relative;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            height: 95px;
            max-height: 95px;
            border-bottom: 3px solid #26ade4;

            .top-message {
                display: none;
            }

            > .go-to-site-btn {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 5px;

                position: absolute;
                left: 20px;
            }

            > img {
                height: 65px;
                /* width: 30vw; */
            }
        }

        .screen-header {
            padding: 5px;
            display: flex;
            flex-direction: row;
            .user {
                margin-left: auto;
            }

            .login-btn {
                min-width: 400px;
            }
        }

        @media (max-width: 992px) {
            header {
                display: flex;
                flex-direction: column;
                justify-content: flex-start;

                gap: 10px;

                height: 120px;
                max-height: 120px;

                .top-message {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    gap: 5px;
                    margin: 0;
                    height: 40px;
                    width: 100vw;
                    background-color: #26ade4;

                    .arrow-icn {
                        color: #fff;
                    }

                    > a {
                        font-size: 16px;
                        appearance: none;
                        color: #fff;
                        text-decoration: none;
                    }
                }

                > img {
                    height: 55px;
                }

                > .go-to-site-btn {
                    display: none;
                }
            }
        }

        @media (max-width: 576px) {
            header {
                > img {
                    max-width: 80vw;
                }
            }

            .screen-header {
                display: flex;
                flex-direction: column;
                align-items: center;
                .user {
                    margin: 0;
                    margin-top: 10px;
                }
                .login-btn {
                    font-size: 12px;
                    min-width: 300px;
                    max-width: 300px;
                }
            }

            main {
                max-width: 100vw;
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default Layout
